import { useMemo } from 'react'

import { PROFILE_BUSINESS_CODE_ENUM } from 'integration/resources/auth'
import { useAuthAtomValue } from 'src/store/auth'

export const useIsGoodsAndServices = (): boolean => {
  const authAtom = useAuthAtomValue()

  return useMemo(
    () => authAtom?.user.business_code === PROFILE_BUSINESS_CODE_ENUM.GOODS_AND_SERVICES,
    [authAtom?.user.business_code]
  )
}
